import React, { Component } from 'react';
import $ from "jquery";

export default class OptSearch_SingleInputText extends Component {

    constructor(props) {
        super(props);
        let data = { ...props.data };
    }

    submitOptForm = (needReload = false) => {
        let match = "{";
        const inputText = $("#search-text").val() || "";

        const OptSearchUrl = window.location.pathname;
        let params = {};

        $("p.selected").text(inputText);
        $("p.selected").attr("data-value", inputText);

        const searchValue = inputText.trim();
        if (searchValue) {
            params["search"] = searchValue;
        }

        $(".search-row").not(".search-row-text").each(function () {
            var title = $(this).children(".search-form__td-title").attr("value");
            var value = $(this).find("li.selected").attr("value");
            //console.log($(this).children(".search-form__td-title").attr("value"));
            //console.log("Title: " + title + ", Value: " + value);
            if (title && value) {
                params[title] = value;
                match += `"${title}":"${value}", `;
                sessionStorage.setItem(title, value);
            }
        });

        let queryString = Object.keys(params)
            .map(key => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');

        //console.log("Query String: " + queryString);

        let newUrl = `${OptSearchUrl}?${queryString}`;
        window.history.pushState(null, '', newUrl);

        if (needReload) {
            //console.log("Reloading page with new parameters.");
            window.location.reload();
        }
    }

    clear = () => {
        sessionStorage.clear();
        window.location.reload();
    }

    componentDidMount() {
        const currentPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        sessionStorage.setItem('OptSearchUrl', currentPath);

        const searchText = String(urlParams.get('search'))
        let setReload = true;
        let optSearchObj = {};

        if (searchText) {
            sessionStorage.setItem('search', searchText);
            optSearchObj["search"] = searchText;
        }

        sessionStorage.setItem('OptSearch', JSON.stringify(optSearchObj));

        this.loadFiltersFromSessionStorage();

        if (!sessionStorage.getItem('submitFormCalled') && setReload) {
            this.submitOptForm();
            sessionStorage.setItem('submitFormCalled', 'true');
        }
    }

    loadFiltersFromSessionStorage() {
        let searchText = sessionStorage.getItem('search');

        const urlParams = new URLSearchParams(window.location.search);
        const searchTextUrl = urlParams.get('search');

        if ((searchText != null && searchText === searchTextUrl)) {
            $("#search-text").val(searchText);
            $("p.selected").text(searchText);
            $("p.selected").attr("data-value", searchText);
        }
    }

    render() {
        document.addEventListener("keypress", function (event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                document.getElementById("search-engine-submit").click();
            }
        });

        $(function () {
            $(".select-container ul").unbind().click(function () {
                $(this).toggleClass("opened");
            });

            $("#optional-search-form ul li").click(function () {
                var match = "{";
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
                $("p.selected").attr("value", inputText)

                if ($(this).hasClass("selected")) {
                }
                else {
                    $(this).addClass("selected").siblings().removeClass("selected");

                    const parentId = $(this).parent("ul").attr('id');
                    const itemValue = $(this).attr("value");
                    sessionStorage.setItem(`id_${parentId}`, itemValue)

                    $(".search-row").each(function () {
                        var title = $(this).children(".search-form__td-title").attr("value");
                        var value = $(this).find(".selected").attr("value");
                        match += '"' + title + '":';
                        match += '"' + value + '", ';
                    });

                }
                match = match.slice(0, -2);
                match += "}";
                sessionStorage.setItem("OptSearch4", match);
            });

            $('#search-text').on('input', function (e) {
                var inputText = $("#search-text").val();
                $("p.selected").text(inputText);
            });

        });

        $(document).mouseup(function (e) {
            var container = $(".select-container ul.opened");
            // if the target of the click isn't the container nor a descendant of the container
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                container.removeClass("opened");
            }
        });


        $(function () {

        })

        // LABELS BASED ON LANGUAGE
        let search_label_1 = window.location.href.indexOf("/en/") > -1 ? "Clear" : "Wyczyść";
        let search_label_2 = window.location.href.indexOf("/en/") > -1 ? "Enter a search phrase" : "Wpisz szukaną frazę";
        let search_label_3 = window.location.href.indexOf("/en/") > -1 ? "Search" : "Szukaj";
        let search_label_4 = window.location.href.indexOf("/en/") > -1 ? "all" : "wszystkie";
        let search_label_5 = window.location.href.indexOf("/en/") > -1 ? "enter..." : "wpisz...";

        return (
            <div className="optional-search-container" style={{ width: "100%", maxWidth: "750px", margin: "15px auto" }}>
                <form id="optional-search-form" className="OptSearchSingle">
                    <table>
                        <tr className="search-row">
                            <td colSpan={2} className="search-row-text search-form__td-title" value="search">
                                <input aria-label={search_label_2} id="search-text" type="text" placeholder={search_label_2} />
                                <p className="selected" style={{ margin: 0 }}></p>
                            </td>
                        </tr>
                    </table>

                    <div className="search-engine-options">
                        <button onClick={this.clear}>{search_label_1}</button>
                        <button id="search-engine-submit" className="submit" onClick={(e) => {e.preventDefault(); this.submitOptForm(true)}}>{search_label_3}</button>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/OptSearch_SingleInputText/OptSearch.js